export default "__VITE_ASSET__DWwNm3CQ__"